import { db } from '../firebase';
import { collection, doc, getDoc, setDoc, updateDoc, increment, serverTimestamp } from 'firebase/firestore';

// Firestore collections
const XP_COLLECTION = 'xp';
const ACHIEVEMENTS_COLLECTION = 'achievements';
const QUESTS_COLLECTION = 'quests';
const BADGES_COLLECTION = 'badges';
const STORE_COLLECTION = 'store';

export const gamificationService = {
  async getUserXP(userId) {
    const ref = doc(db, XP_COLLECTION, userId);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : { xp: 0, level: 1, streak: 0, coins: 0 };
  },
  async addXP(userId, amount) {
    const ref = doc(db, XP_COLLECTION, userId);
    await setDoc(ref, { xp: increment(amount), updatedAt: serverTimestamp() }, { merge: true });
  },
  async setStreak(userId, streak) {
    const ref = doc(db, XP_COLLECTION, userId);
    await updateDoc(ref, { streak, updatedAt: serverTimestamp() });
  },
  async getAchievements(userId) {
    const ref = collection(db, ACHIEVEMENTS_COLLECTION);
    // Query/filter by userId if needed
    // ...
    return [];
  },
  async getQuests(userId) {
    const ref = collection(db, QUESTS_COLLECTION);
    // Query/filter by userId if needed
    // ...
    return [];
  },
  async getBadges(userId) {
    const ref = collection(db, BADGES_COLLECTION);
    // Query/filter by userId if needed
    // ...
    return [];
  },
  async getStoreItems() {
    const ref = collection(db, STORE_COLLECTION);
    // ...
    return [];
  },
  // Add more methods for freeze item, season reset, coins, etc.
};
